import React, { useRef, useEffect, FC, useState } from 'react';
import { useIsomorphicLayoutEffect, useWindowSize } from '@navi-toolbox/hooks';
import { Picture } from './picture';
import { Video } from './video';
import { MediaType, MediaList } from '../types';
import { preview } from './styles';

type Props = {
  active: number;
  alt: string;
  src: string;
  type?: MediaType;
  mediaList: MediaList;
  videoList: MediaList;
  setActive: (index: number) => void;
  onMediaLoad?: (mediaType: string, imgSrc: string, loadTime?: number) => void;
};

export const DATA_QA_PREVIEW = 'preview';
const MARGIN = 16;

export const Preview: FC<Props> = ({ type, ...props }) => {
  const { height } = useWindowSize();
  const ref = useRef<HTMLDivElement | null>(null);
  const [size, setSize] = useState<string | number>('auto');

  useEffect(() => {
    setTimeout(() => {
      ref.current?.style.setProperty('opacity', '1');
    }, 50);
  }, [props.src]);

  useIsomorphicLayoutEffect(() => {
    if (ref?.current) {
      const top = ref.current.getBoundingClientRect().top;
      const bottom = ref.current.getBoundingClientRect().bottom;

      if (bottom + MARGIN > height) {
        setSize(height - top - MARGIN);
      }
    }
  }, [ref, height]);

  return (
    <div ref={ref} className={preview} style={{ height: size, width: size }} data-qa={DATA_QA_PREVIEW}>
      {type === 'image' && <Picture fetchpriority="high" {...props} />}
      {type === 'video' && <Video {...props} />}
    </div>
  );
};
